import { render, staticRenderFns } from "./Unlawful.vue?vue&type=template&id=7720514d&scoped=true&"
import script from "./Unlawful.vue?vue&type=script&lang=js&"
export * from "./Unlawful.vue?vue&type=script&lang=js&"
import style0 from "./Unlawful.vue?vue&type=style&index=0&id=7720514d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7720514d",
  null
  
)

export default component.exports